export enum ClassificationBackfillMode {
  Both = "both",
  Classification = "classification",
  Sentiment = "sentiment",
}
